<template>
    <div class="main_container">
        <div id="background">   
            <div id="line_container">
                <li id="title">계좌</li>
                <div id="basic_text" v-html="bankAccount.replace(/ /g, '&nbsp;&nbsp;')" />
            </div>
            <div id="line_container">
                <li id="title">연락처</li>
                <div id="basic_text" v-text="user_phone" />
            </div>
            <div id="line_container">
                <li id="title">신청액수</li>
                <input id="input_round_box" type="number" v-model="state.form.money" />
            </div>
            <div id="line_container">
                <div id="info_text">◎ 잘못된 정보가 있는 경우 문의 바랍니다.</div>
            </div>
            <button id="btn" @click="withdraw_try()">신청하기</button>
        </div>
    </div>
</template>

<script>
import store from '../../js/store.js'
import { reactive } from '@vue/reactivity'
import API from '@/components/js/API';
import Swal from 'sweetalert2';

export default {
        name: "popup_withdraw",
        components: {

        },
    data() {
        return {
            bankAccount: store.state.user.account || '',
            user_phone: store.state.user.phone,
            state: reactive({
                form: {
                    type: 1,
                    money: '',
                    info: ''
                }
            }),
        }
    },
        methods: {
            withdraw_try: function(){
                API.AxiosPost('memo/registMemo', this.state.form, true,
                    (res) => {
                        console.log(res);
                        if (res.status == 200) {
                            if (res.data.code == 200) {
                                this.$root.ClosePopup();
                                API.showToast('success', '신청되었습니다.');
                            }
                            else {
                                Swal.fire({
                                    icon: 'error',
                                    html: '처리과정에 문제가 발생했습니다.<br>해당 현상 반복시 문의바랍니다.',
                                });
                                console.log("return code : " + res.data.code);
                            }
                        }
                        else {
                                Swal.fire({
                                    icon: 'error',
                                    html: '처리과정에 문제가 발생했습니다.<br>해당 현상 반복시 문의바랍니다.',
                                });
                                console.log("return status : " + res.status);
                            }
                    }
                )
            },
        }
    };
</script>

<style>
#line_container{
    width: 480px;
    height: 40px;
    margin: 20px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}
#title{
    float: left;
    width: 120px;
    height: 100%;
    font-size: 18px;
    font-weight: bold;
    color: white;
    text-align: left;
    margin-top: 10px;
}
#info_text{
    height: 40px;
    width: 100%;
    height: 100%;
    font-size: 18px;
    font-weight: bold;
    color: white;
    text-align: center;
    margin-top: 10px;
}
#input_round_box{
    float: left;
    height: 40px;
    width: 280px;
    border: 1px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    margin-bottom: 10px;
    margin-right: 60px;
    margin-left: 60px;
    padding-left: 20px;
    padding-right: 30px;
    padding-top: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    text-align: right;
}
#input_round_box::placeholder{
    font-size: 13px;
    font-style: italic;
}
#btn{
    height: 40px;
    width: 250px;
    border: 1px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #2d88ff;
    color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>@/components/js/API.js